module.exports = __webpack_public_path__ + "static/media/media2.1bb0e407.png";